import Alert from '@/components/Alert/Alert'
import { Button, ButtonText } from '@/components/ui/button'
import { HStack } from '@/components/ui/hstack'
import { Text } from '@/components/ui/text'
import { cn } from '@/lib/cn'

type Props = {
  points: number | undefined
}

const ALERT_THRESHOLD = 5

export default function AIPointsAlert({ points }: Props) {
  const handleGetAIPoints = () => {
    Alert.alert('AI 点数不足', '本月 AI 点数已用完，请前往电脑端购买 AI 点数或升级套餐后继续创建')
  }

  if (typeof points !== 'number') return null
  if (points > ALERT_THRESHOLD) return null

  return (
    <HStack
      className={cn(
        'items-center justify-between mx-4 px-4 pt-2 pb-8 -mb-6 rounded-xl border',
        points > 0 ? 'bg-warning-50 border-warning-100' : 'bg-error-50 border-error-100'
      )}
    >
      <Text className="text-typography-900">{points === 0 ? '本月 AI 点数已用完' : '本月 AI 点数剩余不足'}</Text>
      <Button action="primary" className="rounded-xl" size="sm">
        <ButtonText onPress={handleGetAIPoints}>获取 AI 点数</ButtonText>
      </Button>
    </HStack>
  )
}
